import EachFeedActivity from './EachFeedActivity'


function DashUserDiscussionTopics({item, date}) {

  return <EachFeedActivity
  title={item?.title}
  desc={item?.description}
  discussion_id={item?.eid}
  topic={item?.topic}
  author={item?.author?.username}
  author_image={item?.author?.user_image}
  date={date}
  mediaFiles={item?.media || []}
  upvote_count={item?.upvote_count}
  downvote_count={item?.downvote_count}
/>
}

export default DashUserDiscussionTopics
